import { useQuery } from 'react-query';
import { designHuddleService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useDesignHuddleToken = (clinid: string | undefined) => {
  return useQuery(
    `${ServerStateKeysEnum.designHuddleToken}`,
    () => {
      return designHuddleService.getDHToken();
    },

    { staleTime: Infinity, enabled: !!clinid }
  );
};
